import React from "react";
import { useNavigate } from "react-router-dom";
import { useCart } from "@/context/CartContext";
import { inr } from "@/lib/api";
import { CART } from "@/constants/testIds";
import { ChevronRight, ShoppingBag } from "lucide-react";

export function StickyCartBar() {
  const { totals } = useCart();
  const navigate = useNavigate();
  if (totals.count === 0) return null;
  return (
    <div data-testid={CART.stickyBar} className="fixed bottom-3 left-3 right-3 z-40 max-w-6xl mx-auto animate-fade-in-up">
      <button
        data-testid={CART.viewCartBtn}
        onClick={() => navigate("/cart")}
        className="w-full bg-hyd-gold text-hyd-bg rounded-2xl px-4 py-3 flex items-center justify-between shadow-glow-gold font-bold hover:bg-hyd-goldDim transition-colors"
        aria-label="View cart"
      >
        <div className="flex items-center gap-3">
          <div className="relative">
            <ShoppingBag className="w-5 h-5" />
            <span className="absolute -top-2 -right-2 min-w-[20px] h-5 px-1 rounded-full bg-hyd-red text-white text-[10px] grid place-items-center">
              {totals.count}
            </span>
          </div>
          <div className="text-left leading-tight">
            <div className="text-xs font-medium opacity-80">{totals.count} item{totals.count > 1 ? "s" : ""}</div>
            <div className="text-base">{inr(totals.subtotal)}</div>
          </div>
        </div>
        <div className="flex items-center gap-1 uppercase tracking-wider text-sm">
          View Cart <ChevronRight className="w-4 h-4" />
        </div>
      </button>
    </div>
  );
}
